const GOOGLE_ANALYTICS_INTERACTION_HIT_FALSE = 'False';

export interface LinkData {
  context: 'Info and contact' | 'About us';
  text: string;
  position: number;
  url: string;
}

export interface FooterLink {
  id: string;
  url?: string;
}

export const GTM_CLICK_ON_B2B_CONNECT_BUTTON = () => ({
  event: 'interaction_click on login b2b',
  e_category: 'account',
  e_action: 'login b2b',
  e_label: 'Footer CTA',
  event_trigger: 'Footer CTA',
  amp_event_name: 'Click on login b2b',
  interaction_hit: GOOGLE_ANALYTICS_INTERACTION_HIT_FALSE,
});

export const GTM_CLICK_ON_FOOTER_LINK = (linkData: LinkData) => ({
  event: 'interaction_click on footer link',
  e_category: 'navigation',
  e_action: 'Click on footer link',
  e_label: linkData.text,
  block_clicked: linkData.context,
  click_element: linkData.text,
  position: linkData.position,
  redirection_link: linkData.url,
  event_trigger: 'Footer CTA',
  amp_event_name: 'Click on footer link',
  interaction_hit: GOOGLE_ANALYTICS_INTERACTION_HIT_FALSE,
});

export const GTM_DISPLAY_NEWSLETTER_FOOTER = (pageType: string) => ({
  event: 'interaction_display footer newsletter subscription',
  e_category: 'navigation',
  e_action: 'Display footer newsletter subscription',
  e_label: pageType,
  event_trigger: pageType,
  amp_event_name: 'Display footer newsletter subscription',
  interaction_hit: 'True',
});

export const GTM_CLICK_ON_APP = (
  appLink: FooterLink,
  eventTrigger?: string,
) => ({
  event: 'interaction_click on app download button',
  e_category: 'navigation',
  e_action: 'Click on app download button',
  e_label: appLink.id,
  click_element: appLink.id,
  redirection_link: appLink.url,
  event_trigger: eventTrigger ?? 'Footer CTA',
  amp_event_name: 'Click on app download button',
  interaction_hit: GOOGLE_ANALYTICS_INTERACTION_HIT_FALSE,
});

export const GTM_CLICK_ON_LEGAL_MENTIONS = (legalMentionsLink: FooterLink) => ({
  event: 'interaction_click on legal mentions link',
  e_category: 'navigation',
  e_action: 'Click on legal mentions link',
  e_label: legalMentionsLink.id,
  click_element: legalMentionsLink.id,
  redirection_link: legalMentionsLink.url,
  event_trigger: 'Footer CTA',
  amp_event_name: 'Click on legal mentions link',
  interaction_hit: GOOGLE_ANALYTICS_INTERACTION_HIT_FALSE,
});
